import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getCurrentUser, getRoles, getUsers } from "../api/user";
import { getUserInfo, getlocalStorageOrDefault } from "../utility/storage";

export const fetchRoles = createAsyncThunk("user/fetchRoles", async () =>
  getRoles().then((res) => res)
);

export const fetchUsers = createAsyncThunk("user/fetchUsers", async (params) =>
  getUsers(params?.page, params?.limit).then((res) => res)
);

export const fetchCurrentUser = createAsyncThunk(
  "user/fetchCurrentUser",
  async () => getCurrentUser().then((res) => res)
);

export const userSlice = createSlice({
  name: "user",
  initialState: {
    roles: [],
    users: [],
    userInfo: getUserInfo() || {},
    userLoggedIn: getlocalStorageOrDefault("userLoggedIn", false),
    loading: false,
  },
  reducers: {
    setUserLoggedIn: (state, { payload }) => {
      state.userLoggedIn = payload;
    },
  },
  extraReducers: {
    [fetchCurrentUser.fulfilled]: (state, { payload }) => {
      state.userInfo = payload;
    },
    [fetchCurrentUser.rejected]: (state, { payload }) => {
      state.userInfo = {};
    },
    [fetchRoles.fulfilled]: (state, { payload }) => {
      state.roles = payload;
    },
    [fetchUsers.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [fetchUsers.fulfilled]: (state, { payload }) => {
      state.users = payload;
      state.loading = false;
    },
    [fetchUsers.rejected]: (state, { payload }) => {
      state.loading = false;
    },
  },
});

export default userSlice.reducer;

export const { setUserLoggedIn } = userSlice.actions;
